import React, {useState} from 'react';
import css from './ExpandableItem.module.scss';
import PropTypes from 'prop-types';
import CardTitle from "../Headings/CardTitle/CardTitle.jsx";
import DownArrow from "../Icons/DownArrow";
import UpArrow from "../Icons/UpArrow";
import {colors} from "../../utils/colors.js";

const ExpandableItem = ({
  icon,
  title,
  titleColor,
  expanded = false,
  className,
  children,
  style,
}) => {
  const [isExpanded, setIsExpanded] = useState(expanded)

  return (
    <div className={`${css.item} ${className}`} style={style}>
      <div
        className={css.title}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        {icon &&
          <div className={css.itemIcon}>
            {icon}
          </div>
        }
        {title && <CardTitle color={titleColor}>{title}</CardTitle>}
        <span>
          {isExpanded ? <UpArrow color={colors.primaryColor}/> : <DownArrow color={colors.primaryColor}/>}
        </span>
      </div>
      {isExpanded &&
        <div className={css.itemContent}>
          {children}
        </div>
      }
    </div>
  );
};

ExpandableItem.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  className: PropTypes.string,
  children: PropTypes.node,
};

export default ExpandableItem;
